import { useTranslation } from 'react-i18next';
import styles from './GameServicesPage.module.less';
import { Card, Col, Row } from 'antd';
import { useHistory } from 'react-router-dom';
import {
	TrophyOutlined,
	DotChartOutlined,
	OrderedListOutlined,
	CloudDownloadOutlined,
} from '@ant-design/icons';
import { useFlags } from 'flagsmith/react';

export default function GameServicesPage() {
	const { t } = useTranslation();
	const history = useHistory();
	const featureFlags = useFlags(['dlc']);

	function handleCardClick(path: string) {
		history.push(`game-services/${path}`);
	}

	return (
		<div className={styles.pageContainer}>
			<div className="page-head">
				<div>
					<h2 className="h2">{t('gameServicesPage.header')}</h2>
				</div>
			</div>
			<Row gutter={16}>
				<Col span={16}>
					<Row gutter={[16, 16]}>
						<Col span={12}>
							<Card
								onClick={() => handleCardClick('achievements')}
								style={{ height: 150 }}
							>
								<TrophyOutlined style={{ fontSize: '26px' }} />
								<h3>{t('gameServicesPage.achievements.header')}</h3>
								<span>{t('gameServicesPage.achievements.subText')}</span>
							</Card>
						</Col>
						<Col span={12}>
							<Card
								onClick={() => handleCardClick('leaderboardsV2')}
								style={{ height: 150 }}
							>
								<OrderedListOutlined style={{ fontSize: '26px' }} />
								<h3>{t('gameServicesPage.leaderboards.header')}</h3>
								<span>{t('gameServicesPage.leaderboards.subText')}</span>
							</Card>
						</Col>
						{featureFlags.dlc?.enabled && (
							<Col span={12}>
								<Card
									onClick={() => handleCardClick('downloadable-content')}
									style={{ height: 150 }}
								>
									<CloudDownloadOutlined style={{ fontSize: '26px' }} />
									<h3>{t('gameServicesPage.downloadableContent.header')}</h3>
									<span>
										{t('gameServicesPage.downloadableContent.subText')}
									</span>
								</Card>
							</Col>
						)}
					</Row>
				</Col>
			</Row>
		</div>
	);
}
